import React from "react";

const NextEpisodeCard = ({
  showNextEpisodeCard,
  nextProgram,
  isSideNavOpen,
  nextEpisodePoster,
  placeholder,
  translate,
  episodeInfoString,
  seriesDetails,
  bingeWatchCard,
  bingeWatchTimer,
  handleEpisodeCardClick,
  cancelAutoplay,
}) => {
  if (!showNextEpisodeCard || !nextProgram) {
    return null;
  }

  const showName =
    seriesDetails?.title ||
    nextProgram.metadata?.extendedMetadata?.dlum?.sortTitle ||
    nextProgram.metadata?.title ||
    "";
  const userHaseBookmarks = nextProgram.userData?.metadata?.bookmarks?.length > 0;

  return (
    <div className="next-episode" style={isSideNavOpen ? { visibility: "hidden" } : { visibility: "visible" }}>
      <div
        className="episode-card"
        style={{
          backgroundImage: `url(${nextEpisodePoster}?w=230), url(${placeholder}`,
        }}
      ></div>
      <div className="card-text">
        <div className="label">{translate("next_episode")}</div>
        <div className="show-name">{showName}</div>
        <div className="episode-info-container">
          <div className="episode-info">
            <span>{episodeInfoString()}</span>
          </div>
          {userHaseBookmarks ? <img src={process.env.PUBLIC_URL + "/images/tick-icon.svg"} alt="Channel Logo" /> : null}
        </div>
      </div>
      <div className="binge-watch-button-container" ref={bingeWatchCard}>
        <button
          className="binge-watch-buttons timer-bg"
          style={{ animation: `timer ${bingeWatchTimer}s` }}
          onClick={handleEpisodeCardClick}
        >
          {translate("play")}
        </button>
        <button className="binge-watch-buttons dismiss-bg" onClick={cancelAutoplay}>
          {translate("dismiss")}
        </button>
      </div>
    </div>
  );
};

export default NextEpisodeCard;
